import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
  UncontrolledTooltip,
} from "reactstrap";
import { FaPhone, FaHome, FaUser } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import moment from "moment";
import ClassnoteModal from "models/classnote.modal";
const Summary = ({ data, detail }) => {
  const [modal, setModal] = useState();
  const [modal1, setModal1] = useState();
  const parmas = useParams();
  const joinedDate = moment(data?.user?.date_joined).format("YYYY-MM-DD");

  const toggle = () => {
    setModal(!modal);
  };
  const toggle1 = () => {
    setModal1(!modal1);
  };

  const AddCore = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("class_id", parmas?.mid);
    form.append("type", "requirement");

    ClassnoteModal.Add(form)
      .then((responce) => {
        GetCore();
        toggle();
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  console.log("ggggg",detail);
  console.log("hhh",data)
  const AddNote = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("class_id", parmas?.mid);
    form.append("type", "notes");

    ClassnoteModal.Add(form)
      .then((responce) => {
        GetNotes();
        toggle1();
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const [notedata, setNotedata] = useState();
  const [coredata, setCoredata] = useState();

  const GetNotes = async () => {
    ClassnoteModal.get("notes", parmas?.mid)
      .then((responce) => {
        setNotedata(responce?.data?.data);
      })
      .catch((error) => {});
  };
  const GetCore = async () => {
    ClassnoteModal.get("requirement", parmas?.mid)
      .then((responce) => {
        setCoredata(responce?.data?.data);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    GetNotes();
    GetCore();
  }, []);
  const [showAll, setShowAll] = useState(false);
  const toggleShowAll = () => setShowAll((prev) => !prev);
 
  return (
    <div>
      <Card className="mb-3 w-100" style={{ borderRadius: ".5rem" }}>
        <Row className="g-0">
          <Col
            md="2"
            className="gradient-custom text-center text-white mt-4 "
            style={{
              backgroundColor: "#000f26",
              height: "120px",
              width: "100px",
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "10px",
            }}
          >
            <div
              style={{
                width: "80px",
                height: "80px",
                backgroundColor: "#000f26", // Ensure the same background color is applied
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "10px",
                }}
                src={`https://cliply.co/wp-content/uploads/2020/09/442008571_ARTIST_AVATAR_3D_400px.gif`}
                alt="avatar"
              />
            </div>
          </Col>
          <Col md="10">
            <CardBody>
              <Container style={{ border: "1px solid #ccc" }}>
                <Row>
                  <Col md={8} style={{ borderRight: "1px solid #ccc" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px",
                        marginTop: "5px",
                      }}
                    >
                      <FaUser className="me-2 mr-1" />
                      <span>
                        Parent - {detail?.parentData?.first_name}{" "}
                        {detail?.parentData?.last_name}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <FaPhone className="me-2 mr-1" />

                      <span className="ms-3">
                        {detail?.parentData?.username}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <FaHome className="me-2 mr-1" />
                      <span>
                        {detail?.city} {detail?.state}
                      </span>
                    </div>
                  </Col>
                  <Col md={4}>
                    {/* <div style={{ marginBottom: "10px" }}>
                      <strong>ID:</strong> <span>2977748</span>
                    </div>*/}
                    <div style={{ marginBottom: "10px" }}>
                      <strong>Date of Joining:</strong>{" "}
                      <span>{detail?.Created_ON}</span>
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                      <strong>Student:</strong>{" "}
                      {data?.students?.map((item, index) => {
                        return <>{item?.name}</>;
                      })}
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                      <strong>Tutor:</strong>{" "}
                      <span>
                        {detail?.tutorData?.first_name}{" "}
                        {detail?.tutorData?.last_name}{" "}
                      </span>
                      <br />
                      <strong>Badge/Level:</strong> {detail?.badge}
                    </div>
                  </Col>
                </Row>
              </Container>
            </CardBody>
          </Col>
        </Row>
      </Card>

      <Container
        style={{ marginTop: "20px", padding: "20px", border: "1px solid #ccc" }}
      >
        <Row className="mb-3">
          <Col md={10}>
            {/* <h5 style={{ marginBottom: '20px' }}>Package</h5> */}

            <h3 style={{ marginBottom: "20px" }}>Package</h3>
          </Col>
          {/*<Col>
            <Button color="primary">Change</Button>
          </Col>*/}
        </Row>
        <Row>
          <Col md={4}>
            <table borderless>
              <tbody>
                <tr>
                  <td>Fee Charge per hour</td>
                  <td>₹ {detail?.hourly_fee}</td>
                </tr>
                <tr>
                  <td>Tutor Salary per hour</td>
                  <td>₹ {detail?.hourly_payscale}</td>
                </tr>
              </tbody>
            </table>
          </Col>
          <Col md={4}>
            <table borderless>
              <tbody>
                <tr>
                  <td>Sessions a week</td>
                  <td>{detail?.number_of_session / 4} sessions | {detail?.hours / 4} hour</td>
                </tr>
                <tr>
                  <td>Sessions in a month</td>
                  <td>{detail?.number_of_session} sessions / {detail?.hours} hours</td>
                </tr>
              </tbody>
            </table>
          </Col>
          <Col md={4}>
            <table borderless>
              <tbody>
                <tr>
                  <td>Monthly Fee</td>
                  <td>Monthly payscale</td>
                  <td>Pay</td>
                </tr>
                <tr>
                  <td>{detail?.monthly_fee}</td>
                  <td>{detail?.monthly_payscale}</td>
                  <td>{detail?.monthly_fee - detail?.monthly_payscale}</td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
      </Container>

      <Row>
        <div className="col mt-3">
          <Card className="shadow">
            <CardHeader className="border-0 d-flex justify-content-between ">
              <h3 className="mb-0">Students List</h3>
            </CardHeader>

            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">S.No.</th>
                  <th scope="col">Student NAME</th>
                  <th scope="col">Academic</th>
                  <th scope="col">Board</th>
                  <th scope="col">Class</th>
                  <th scope="col">Subject</th>

                  <th scope="col">Gender</th>
                  <th scope="col">Date of Birth</th>
                  <th scope="col"> School/College/University Name</th>
                  <th scope="col">Preferred Time Duration</th>
                  <th scope="col">Tuition Tenure</th>
                  <th scope="col">Location Preference</th>
                  {/* <th scope="col"> Enquiry For</th> */}
                  <th scope="col"> Loaction City</th>
                  <th scope="col"> Tutors Level</th>
                  {/*<th scope="col">Action</th>*/}
                </tr>
              </thead>

              {true && (
                <tbody>
                  {detail?.studentData?.map((item, index) => {
                    return (
                      <tr style={{ cursor: "pointer" }}>
                        <td>{index + 1}</td>
                        <td>{item?.name || "-"}</td>
                        <td>{"new" || "-"}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>{item?.gender}</td>
                        <td> </td>
                        <td>{item?.school_name}</td>
                        <td>{item?.preferrd_time}</td>
                        <td></td>
                        <td></td>
                        {/* <td  >{item?.Enquiry_For || "Student"}</td> */}
                        <td></td>
                        <td></td>
                        {/*<td
                      className="pl-4 p-0"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        // justifyContent: "center",
                        // alignItems: "center",
                      }}
                    >
                      <UncontrolledTooltip placement="top" target="eyeTooltips">
                        Edit
                      </UncontrolledTooltip>
                      <Link
                        id="eyeTooltips"
                        style={{
                          margin: "0 5px",
                          fontSize: "15px",
                          color: "blue",
                          // backgroundColor: "#f5f5f5",
                          alignItems: "center",
                          display: "inline-block",
                          marginTop: "10px",
                          // padding: "5px", // Optional: Add padding for better appearance
                          borderRadius: "30%", // Optional: Make it a circle
                        }}
                        tag={Link}
                        // to={`/admin/viewenquiry/EditEnquriParentDetails/${parmas.mid}/${parmas.id}/${item.id}`}
                      >
                        <i className="fa-solid fa-pen-to-square"></i>
                      </Link>

                      <UncontrolledTooltip placement="top" target="userTooltip">
                        Delete
                      </UncontrolledTooltip>
                      <p
                        style={{
                          margin: "0 8px",
                          fontSize: "15px",
                          color: "red",
                          marginTop: "10px",
                          // backgroundColor: "#f5f5f5",
                          display: "inline-block",
                          // padding: "5px", // Optional: Add padding for better appearance
                          borderRadius: "20%", // Optional: Make it a circle
                        }}
                        id="userTooltip"
                        // onClick={() => handleDel(item.id)}
                      >
                        <i className="fas fa-trash"></i>
                      </p>
                    </td>*/}
                      </tr>
                    );
                  })}
                </tbody>
              )}
            </Table>
          </Card>
        </div>
      </Row>

      <Container style={{ marginTop: "20px", padding: "20px" }}>
        <Row>
          <Col md={6}>
            <Card style={{ border: "1px solid #ccc" }}>
              <CardBody>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <CardTitle tag="h3" style={{ marginBottom: "20px" }}>
                    Core Requirements
                  </CardTitle>
                  <Button color="primary" size="sm" onClick={toggle}>
                    <FaPlus /> Add
                  </Button>
                </div>
                <div style={{ maxHeight: "400px", overflowX: "auto" }}>
                  {coredata?.map((item, index) => {
                    return (
                      <div
                        style={{
                          border: "1px solid lightgray",
                          marginBottom: "2px",
                          padding: "4px",
                        }}
                        key={index}
                      >
                        <CardText>{item?.notes}</CardText>
                        <CardText className="text-end">
                          {moment(item.updatedAt).format("DD/MM/YYYY HH:mm A")}
                        </CardText>
                      </div>
                    );
                  })}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col md={6}>
            <Card style={{ border: "1px solid #ccc" }}>
              <CardBody>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <CardTitle tag="h3" style={{ marginBottom: "20px" }}>
                    Note
                  </CardTitle>
                  <Button color="primary" size="sm" onClick={toggle1}>
                    <FaPlus /> Add
                  </Button>
                </div>
                <div style={{ maxHeight: "400px", overflowX: "auto" }}>
                  {notedata
                    ?.slice(0, showAll ? notedata.length : 1)
                    .map((item, index) => (
                      <div className="mb-2" key={index}>
                        <CardText index={index}>{item?.notes}</CardText>
                        <CardText>
                          <small className="text-muted">
                            Written by {item?.auth_user.first_name}{" "}
                            {item?.auth_user.last_name}
                          </small>
                        </CardText>
                        <CardText className="text-end">
                          {moment(item.updatedAt).format("DD/MM/YYYY hh:mm A")}
                        </CardText>
                      </div>
                    ))}
                </div>
                {/* Toggle button */}
                <a
                  href="#"
                  className="text-primary"
                  onClick={(e) => {
                    e.preventDefault(); // Prevent default anchor behavior
                    toggleShowAll();
                  }}
                >
                  {showAll ? "Show less Notes" : "Show all Notes"}
                </a>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Add Core requirement</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={AddCore}>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Note</Label>
                  <Input
                    id="forType"
                    type="textarea"
                    rows="3"
                    name="notes"
                    placeholder="Enter text"
                  />
                </FormGroup>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle}>
                Cancel
              </Button>
              <Button
                type="submit"
                style={{
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
              >
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal isOpen={modal1} toggle={toggle1}>
        <ModalHeader toggle={toggle1}>
          <h4>Add Notes</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={AddNote}>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Note</Label>
                  <Input
                    id="forType"
                    type="textarea"
                    rows="3"
                    name="notes"
                    placeholder="Enter text"
                  />
                </FormGroup>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle1}>
                Cancel
              </Button>
              <Button
                type="submit"
                style={{
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
              >
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Summary;
